<template>
    <section>
      <div class="page-wrapper">
			<!-- Page Body Start-->
			<div class="container-fluid p-0">
				<div class="comingsoon">
					<div class="comingsoon-inner text-center"><img src="@/assets/TAJimages/logo/login.png" width="400" alt="">
						<h5>WE ARE COMING SOON</h5>
					</div>
				</div>
			</div>
		</div>
    </section>
</template>
<script>
  export default {
    name: 'comingSoon',
    data:() => ({
    }),
    mounted() {
    },
  };
</script>
<style scoped>
.comingsoon {
  min-height: 70vh !important;
}
.comingsoon-inner h5 {
  font-size: 25px !important;
}
</style>